module.exports = __webpack_public_path__ + "img/settings.f89510de.svg";